/* global FS */

import { camelCase, forOwn } from 'lodash';

/**
 * Record custom user data
 * Reference: http://help.fullstory.com/develop-js/setuservars
 */
export function setUserVars(data) {
    if (typeof FS === 'undefined') return;

    forOwn(data, (value, key) => {
        FS.setUserVars({ [formatCustomFieldName(key)]: value });
    });
}

/**
 * Format the experiment IDs for Fullstory
 * The field names must be: alphanumeric, camelCase, and ending in `_${type}` ('_str' in our case)
 * Reference: http://help.fullstory.com/develop-js/setuservars
 */
export function formatCustomFieldName(fieldName) {
    return `${camelCase(fieldName)}_str`;
}
